/// <amd-module name="Build/DesignerExtensions/YamlAssistant/YamlAssistantView" />
import * as React from "react";

import { Components, VssComponent } from "VSS/Platform/Layout";
import { IVssPageContext, IVssService, Services } from "VSS/Platform/Context";

import { SnippetList } from "Build/DesignerExtensions/YamlAssistant/Components/SnippetList";
import { YamlSnippet } from "Pipelines/Common/Library/Contracts/DataProvider";
import { ContributedSnippetForm } from "Build/DesignerExtensions/YamlAssistantLibrary/Components/ContributedSnippetForm";
import { YamlAssistantProvider, YamlGeneratedEvent, YamlGeneratedType } from "Build/DesignerExtensions/YamlAssistantLibrary/Contracts/Types";
import { SnippetListSource } from "Build/DesignerExtensions/YamlAssistant/Sources/SnippetListSource";

export interface YamlAssistantViewState {
    snippet?: YamlSnippet;
    startingParameters?: {[key: string]: string};
}

export class YamlAssistantView extends VssComponent<YamlAssistantProvider, YamlAssistantViewState> {
    private _source: SnippetListSource;

    constructor(props: YamlAssistantProvider) {
        super(props);

        this.state = {};
    }

    public render(): JSX.Element {
        return <div className={"yaml-assistant-view flex-column flex-grow"}>
            {
                this.state.snippet
                    ? <ContributedSnippetForm
                        onYamlGenerated={this._onYamlGenerated}
                        onDismiss={this._clearSnippet}
                        snippet={this.state.snippet}
                        startingParameters={this.state.startingParameters} />
                    : <SnippetList
                        getSnippets={this._getSnippets}
                        onDismiss={this.props.onDismiss}
                        onSnippetSelected={this._onSnippetSelected} />
            }
        </div>;
    }
    
    public componentDidMount() {
        super.componentDidMount();

        const service = this.context.pageContext.getService<YamlAssistantViewService>("YamlAssistantViewService");
        service.setView(this);
    }

    private _onYamlGenerated = (yamlString: string) => {
        const yamlGeneratedEvent: YamlGeneratedEvent = {
            yamlString,
            eventType: YamlGeneratedType.Snippet,
        };

        this.props.onYamlGenerated(yamlGeneratedEvent);
    }

    private _getSnippets = (): YamlSnippet[] => {
        if (!this._source) {
            this._source = new SnippetListSource(this.context.pageContext);
        }

        return this._source.getSnippets();
    }

    private _onSnippetSelected = (snippet: YamlSnippet) => {
        this.setState({ snippet, startingParameters: undefined });
    }

    private _clearSnippet = () => {
        this.setState({ snippet: undefined, startingParameters: undefined });
    }
    
    public async onStartTask(taskName: string, taskVersion: string, parameters: any) {
        const snippet = await this._source.getSnippet(taskName, taskVersion);
        if (snippet) {
            // clear out the existing snippet to ensure everything is reset
            this.setState({snippet: undefined}, () => {
                this.setState({ snippet, startingParameters: parameters });
            });
        }
    }
}

export class YamlAssistantViewService implements IVssService {
    private _view: YamlAssistantView;

    public setView(view: YamlAssistantView) {
        this._view = view;
    }

    public onStartTask(taskName: string, taskVersion: string, parameters: any) {
        this._view && this._view.onStartTask(taskName, taskVersion, parameters);
    }

    public _serviceStart = (pageContext: IVssPageContext) => {};
    public _serviceEnd() {};
}

Services.add("YamlAssistantViewService", { serviceFactory: YamlAssistantViewService });
Components.add("yaml-assistant-view", YamlAssistantView);
